import { createFileRoute } from '@tanstack/react-router'

import { AdminReportsPage } from '@/pages/admin/reports/admin-reports-page'

export const Route = createFileRoute('/_private/admin/reports')({
  component: AdminReportsPage,
})
